import { FC } from 'react'
import { useAppSelector } from '../../store/hooks'
import { ParticipationStatus as ParticipationStatusModel } from '../../models/Event'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { selectParticipationStatusById } from '../../store/membership/ParticipationStatusReducer'

type Props = SBModelComponent<ParticipationStatusModel> & {}

const ParticipationStatusOption: FC<Props> = ({ id, model }) => {
  const item = model
    ? model
    : useAppSelector(selectParticipationStatusById(id!))

  if (!item) {
    return <></>
  }

  return item.name
}

type ParticipationStatusOptionType = {
  Option: typeof ParticipationStatusOption
}

export { ParticipationStatusOption, type ParticipationStatusOptionType }
